export function getDocumentInfo(message: string, docType: string) {
        let tipoDoc = message.split('-')[1].split(':')[1].trim();

        if (tipoDoc.match(/^[a-zA-Z]/)) {
            const escapedDocType = docType.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            var re = new RegExp(`${escapedDocType}[A-Za-z0-9]{3}-[0-9]{8}`);
            var OK = re.exec(message);

            if (OK) {
                return OK[0];
            } else {
                console.error(`No se consiguió el nombre del documento para el tipo ${docType}`);
                return null;
            }
        }

        var re = /Numero: (\d+-\d+)/;
        var match = message.match(re);

        if (match) {
            return match[1];
        } else {
            console.error('No se consiguió el número del documento');
            return null;
        }
    }




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/util/util-type-name.ts